import notification from '@atoms/Notification';
import { EMPTY_OBJ } from '@constants';

import useMutation from './useMutation';
import useQuery from './useQuery';

import api from '..';

export const useGameBanner = ({ id }, queryConfig = {}) => {
  const queryResult = useQuery(['game-banners', { id }], api.gameBanners.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    gameBanner: queryResult.data || EMPTY_OBJ,
    ...queryResult,
  };
};

const createGameBannerMutation = (apiCall) => (queryConfig = {}) =>
  useMutation(apiCall, {
    onSuccess: () => notification.success({ message: 'Successfully saved game banner ' }),
    onError: () => notification.error({ message: 'Failed to save game banner' }),
    ...queryConfig,
  });

export const useCreateGameBanner = createGameBannerMutation(api.gameBanners.create);
export const useUpdateGameBanner = createGameBannerMutation(api.gameBanners.update);
